import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const DESTINATIONS = [
  {
    code: "PL",
    name: "Poland",
    city: "Warsaw · Kraków · Wrocław",
    stat: "EU Degree",
    img: "https://images.pexels.com/photos/28299448/pexels-photo-28299448.jpeg",
    coord: "52.2297° N",
  },
  {
    code: "DE",
    name: "Germany",
    city: "Berlin · Munich · Heidelberg",
    stat: "Low/No Tuition",
    img: "https://images.pexels.com/photos/32863809/pexels-photo-32863809.jpeg",
    coord: "52.5200° N",
  },
  {
    code: "UK",
    name: "United Kingdom",
    city: "Manchester · Edinburgh · Belfast",
    stat: "1-yr Masters",
    img: "https://images.pexels.com/photos/10559040/pexels-photo-10559040.jpeg",
    coord: "51.5074° N",
  },
  {
    code: "IE",
    name: "Ireland",
    city: "Dublin · Cork · Galway",
    stat: "2-Yr Stay Back",
    img: "https://images.pexels.com/photos/2416653/pexels-photo-2416653.jpeg",
    coord: "53.3498° N",
  },
  {
    code: "EU",
    name: "Other Schengen",
    city: "Paris · Milan · Santorini",
    stat: "29 Countries",
    img: "https://images.pexels.com/photos/1010657/pexels-photo-1010657.jpeg",
    coord: "48.8566° N",
  },
];

export default function Destinations() {
  return (
    <section
      id="destinations"
      className="relative py-24 md:py-32 bg-[#FDFDFD]"
      data-testid="destinations-section"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        <div className="flex items-end justify-between mb-14 md:mb-20 gap-8 flex-wrap">
          <div>
            <span className="section-label mb-6 inline-flex">
              CH · 04 / Destinations
            </span>
            <h2 className="font-display text-[#0a192f] text-4xl sm:text-5xl md:text-6xl tracking-[-0.025em] leading-[0.98] max-w-3xl mt-6">
              Five skylines. Endless{" "}
              <span className="italic font-normal">flight paths.</span>
            </h2>
          </div>
          <p className="text-[#0a192f]/60 max-w-sm font-body">
            Each destination is curated for tuition value, post-study work
            rights, and quality of life. Ask us why.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 md:gap-8">
          {DESTINATIONS.map((d, i) => (
            <motion.a
              key={d.code}
              href="#contact"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{
                duration: 0.8,
                delay: i * 0.1,
                ease: [0.22, 1, 0.36, 1],
              }}
              whileHover={{ y: -8 }}
              className="group relative block"
              data-testid={`destination-${d.code.toLowerCase()}`}
            >
              <div className="relative aspect-[3/4] overflow-hidden clip-notched bg-[#0a192f]">
                <img
                  src={d.img}
                  alt={d.name}
                  className="w-full h-full object-cover grayscale-hover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#0a192f]/70" />
                <div className="absolute top-4 left-4 right-4 flex items-center justify-between text-white font-mono-tech text-[10px]">
                  <span>◈ {d.code}</span>
                  <span className="opacity-70">{d.coord}</span>
                </div>
                <div className="absolute bottom-5 left-5 right-5 text-white">
                  <div className="font-display text-2xl md:text-3xl tracking-tight leading-none mb-2">
                    {d.name}
                  </div>
                  <div className="font-mono-tech text-[10px] opacity-80 tracking-wider">
                    {d.city.toUpperCase()}
                  </div>
                </div>
                <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 translate-y-[-4px] group-hover:translate-y-0 transition-all duration-500">
                  <div className="w-10 h-10 rounded-full bg-[#00A3FF] flex items-center justify-center">
                    <ArrowUpRight size={16} className="text-white" />
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between mt-5">
                <span className="link-hover" data-testid={`destination-${d.code.toLowerCase()}-cta`}>
                  Learn Admission Req.
                </span>
                <span className="font-mono-tech text-[10px] text-[#0a192f]/50 tracking-wider">
                  {d.stat}
                </span>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
